import React from 'react';
import { Button } from 'react-bootstrap';


const Footer = () => {
  return (
    <div>
    <span className='d-block text-center'>
      If you have any questions or need help contact us <a href="/Contact">here</a>
    </span>
    <footer style={{ backgroundColor: '#31572C', color: 'white', padding: '10px 50px', textAlign: 'center', position: 'relative' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px',marginTop: '10px' }}>
        <Button
          href="/ApplyForHelp"
          style={{ backgroundColor: "#ABC399", borderColor: "#31572C", width: "200px", color: 'black' }}
          className="nav-button"
          target=""
        >
          Apply For Help
        </Button>
            <div style={{ marginBottom: '0px', fontSize: '18px', fontWeight: 'bold', marginTop: '20px' }}>
        Greater Austin Muslim Relief Committee (GAMRC)
      </div>
        <Button
          href="/PayZakatHere"
          style={{ backgroundColor: "#42226D", borderColor: "#42226D", width: "200px" }}
          className="nav-button"
          target="_blank"
        >
          Pay Zakat Here
        </Button>
      </div>
  
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span>Nueces Mosque • ICGA • ICRR • ICBC • ICLT • GIC • QCIC • Al-Noor MCC • ICHC</span>
      </div>
    </footer>
    </div>
  );
};

export default Footer;
